<template>
    <div class="my-4 ml-4 ">
        <b-button @click="addReview" variant="primary" class="mr-2">
            <b-icon icon="star" aria-hidden="true"></b-icon> Write a Review
        </b-button>
        <b-button variant="outline-secondary" class="mr-2">
            <b-icon icon="camera" aria-hidden="true"></b-icon> Add a Photo
        </b-button>
        <b-button variant="outline-secondary" class="mr-2">
            <b-icon icon="share" aria-hidden="true"></b-icon> Share
        </b-button>
        <b-button variant="outline-secondary">
            <b-icon icon="bookmark" aria-hidden="true"></b-icon> Save
        </b-button>
    </div>
</template>

<style scoped>

</style>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        // duplicate on Reviews.vue
        addReview() {
            console.log('addReview clicked')
            history.pushState(
                {},
                null,
                this.$route.path + '/addreview'
            )
            this.$router.push({
                name: 'AddReview',
                params: {}
            })
        }
    }
}
</script>